import { render } from "./Headers.vue?vue&type=template&id=2bdcba04&scoped=true"
import script from "./Headers.vue?vue&type=script&lang=js"
export * from "./Headers.vue?vue&type=script&lang=js"

import "./Headers.vue?vue&type=style&index=0&id=2bdcba04&lang=scss&scoped=true"

import exportComponent from "D:\\work\\jp\\cbredata\\creis_develop\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bdcba04"]])

export default __exports__